import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { compose } from 'recompose';

import Coach from '../../../../../../../Model/Coach';
import AssignmentNotificationSetting from '../AssignmentNotificationSetting';
import texts from './texts.json';

const WorkoutAssignmentNotification = ({ coachDoc }) => {
  const onSave = useCallback((value) => (
    coachDoc.setWorkoutAssignmentClientNotificationEnabled(value)
  ), [coachDoc]);

  return (
    <AssignmentNotificationSetting
      isEnabled={coachDoc.isWorkoutAssignmentClientNotificationEnabled}
      onSave={onSave}
      texts={texts}
    />
  );
};

WorkoutAssignmentNotification.propTypes = {
  coachDoc: PropTypes.instanceOf(Coach).isRequired,
};

export default compose(
  observer,
)(WorkoutAssignmentNotification);
